import OrderPackingLists from "@iewcasia/Components/OrderPackingLists";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import React, { useContext } from "react";
import { connect } from "react-redux";

const OrderDetailsPackingLists = () => {
    const order = useContext(OrderStateContext)?.value as any;

    return order ? (
      <OrderPackingLists {...order} />
    ) : null;
};

const widgetModule: WidgetModule = {
    component: connect(null)(OrderDetailsPackingLists),
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        displayName: "Order Packing Lists",
        group: "Order Details",
    },
};

export default widgetModule;
